// extracted by mini-css-extract-plugin
export default {"container":"OpenCard_container__hQDwU","heading":"OpenCard_heading__DDqPT","content":"OpenCard_content__pO+aC"};